import moment from "moment";
import FormulaLayoutUI from "./FormulaLayoutUI";

import { multiply, sum, subtract } from "lodash";

const getMinValue = (...args) => {
  if (args.length === 0) {
    throw new Error("At least one number must be provided");
  }

  let smallest = Number(args[0]);

  for (let i = 1; i < args.length; i++) {
    if (Number(args[i]) < smallest || smallest === 0) {
      if (args[i] !== 0) {
        smallest = Number(args[i]);
      }
    }
  }
  return smallest;
};

const MillerFinalAmount = ({
  isReached = false,
  other_deduction=0,
  dispatch,
  net_weight,
  received_weight=0,
  returnBagQty=0,
  miller_bill_weight,
  unit,
  contract_type,
  miller_advance,
  gst_charge,
  miller_brokerage,
  bri_brokerage,
  rate,
  tds_amount,
  miller_bill_amount,
  cashDiscount,
  arrivalDate,
  module,
  isMillerModule=false,
}) => {
  console.log(cashDiscount, net_weight, isReached, "cashDiscount=");
  const discountAmount =
    module === "Arrival"
      ? cashDiscount?.discount
        ? cashDiscount?.expiry_days && !isReached
          ? moment(arrivalDate || new Date()).add(
              Number(cashDiscount?.expiry_days) - 1,
              "days"
            ) >= moment(new Date())
            ? Number(
                rate * (Number(cashDiscount?.discount || 0) / 100)
              ).toFixed(2)
            : 0
          : Number(rate * (Number(cashDiscount?.discount || 0) / 100)).toFixed(
              2
            )
        : 0
      : 0;
  const finalRate = Number(rate).toFixed(2) - Number(discountAmount);

  const nw = contract_type !== "FOR"
  ? Number(getMinValue(dispatch, net_weight,miller_bill_weight) - Number(returnBagQty || 0)).toFixed(3)
  : Number(getMinValue(dispatch, net_weight, received_weight, miller_bill_weight) - Number(returnBagQty || 0))
  const brokerage = Number(Number(miller_brokerage || 0).toFixed(2));
  // contract_type === "EX FACTORY" ? Number(miller_brokerage) : 0;
  // sum([bri_brokerage, miller_brokerage]);
  const middleVal = Number(
    subtract(
      Number(sum([multiply(nw, finalRate), gst_charge])),

      sum([miller_advance, tds_amount, brokerage, isMillerModule ? other_deduction : 0])
    )
  ).toFixed(2)
  const finalVal = getMinValue(
    miller_bill_amount,
    middleVal
  ).toFixed(2);
  return (
    <FormulaLayoutUI>
      <div style={{ marginBottom: "18px" }}>
        <strong style={{ fontSize: "15px" }}>
         {module === "Arrival" ? " Miller Final Amount Formula" : " Miller Total Amount Formula"}
        </strong>
      </div>

      {/* Contract Rate */}
      <div style={{ fontSize: "13px", marginBottom: "8px" }}>
        Contract Rate: <strong>₹ {rate}</strong>
      </div>
       {returnBagQty > 0 && <div style={{ fontSize: "13px", marginBottom: "8px" }}>
        Return Bag Qty: <strong>{returnBagQty} {unit}</strong>
      </div>}

      {/* Cash Discount (only for Arrival) */}
      {module === "Arrival" && (
        <div
          style={{
            fontSize: "13px",
            padding: "8px 10px",
            border: "1px solid #e0e0e0",
            borderRadius: "6px",
            marginBottom: "12px",
          }}
        >
          <div>
            Cash Discount:{" "}
            <strong>
              {cashDiscount?.discount
                ? `${cashDiscount?.discount}%`
                : "No Cash Discount"}
            </strong>
          </div>

          {cashDiscount?.expiry_days && (
            <div style={{ marginTop: "4px", color: "#555" }}>
              Valid Till:{" "}
              {moment(arrivalDate || new Date())
                .add(Number(cashDiscount?.expiry_days) - 1, "days")
                .format("DD-MM-YYYY")}
            </div>
          )}

          <div style={{ marginTop: "6px" }}>
            Final Rate = ₹ {rate} − ₹ {discountAmount} ={" "}
            <strong>₹ {finalRate}</strong>
          </div>
        </div>
      )}

      {/* Final Net Weight */}
      <div
        style={{
          marginBottom: "12px",
          padding: "8px 10px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "13px",
        }}
      >
        <div>
          Final Net Weight = {contract_type !== "FOR"
          ? `min(Miller Bill Weight, Dispatch Weight, Net Weight(Dispatch)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}` 
          : `min(Miller Bill Weight, Dispatch Weight, Port Received Weight, Net Weight(Arrival)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}`}
        </div>

        <div style={{ marginTop: "4px", color: "#555" }}>
          {contract_type !== "FOR"
          ? `= min(${miller_bill_weight}, ${dispatch}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}`
          : `= min(${miller_bill_weight}, ${dispatch}, ${received_weight}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}`}
        </div>

        <div style={{ marginTop: "6px" }}>
          Final Net Weight:{" "}
          <strong>
            {Number(nw).toFixed(3)} {unit}
          </strong>
        </div>
      </div>

      {/* Final Amount */}
      <div
        style={{
          padding: "10px 12px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "13px",
        }}
      >
        <div>
          {isMillerModule
          ?`Final Amount = min( Miller Bill Amount, (Final Net Weight × Final Rate) + GST − Advance − TDS − Miller Brokerage - Other Deduction )`
          :`Final Amount = min( Miller Bill Amount, (Final Net Weight × Final Rate) + GST − Advance − TDS − Miller Brokerage )`}
        </div>

        <div style={{ marginTop: "6px", color: "#555" }}>
          = min({miller_bill_amount}, ({nw} × {finalRate}) + {gst_charge} −{" "}
          {miller_advance} − {tds_amount} − {brokerage} {isMillerModule ? `- ${other_deduction}` : ""})
        </div>
        <div style={{ marginTop: "6px", color: "#555" }}>
          = min({miller_bill_amount}, {middleVal})
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: "15px",
            fontWeight: "600",
          }}
        >
          Final Amount: ₹ {Number(finalVal).toFixed(3)}
        </div>
      </div>
    </FormulaLayoutUI>
  );
};

export default MillerFinalAmount;
